import { render, staticRenderFns } from "./bf-input-wrapper.vue?vue&type=template&id=5c2a5bae&"
import script from "./bf-input-wrapper.vue?vue&type=script&lang=js&"
export * from "./bf-input-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports